import { render } from "./PlagiarismAiProtocolForm.vue?vue&type=template&id=58e5047e&scoped=true&ts=true"
import script from "./PlagiarismAiProtocolForm.vue?vue&type=script&lang=ts"
export * from "./PlagiarismAiProtocolForm.vue?vue&type=script&lang=ts"

import "./PlagiarismAiProtocolForm.vue?vue&type=style&index=0&id=58e5047e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e5047e"]])

export default __exports__